import * as React from "react";
const Dashboard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={18} fill="none">
    <path
      fill="#fff"
      d="m14 8.78 4.24-7.33 1.73 1-5.23 9.05-6.51-3.75L3.46 16H20v2H0V0h2v14.54L7.5 5 14 8.78Z"
    />
  </svg>
);
export default Dashboard;
